// extracted by mini-css-extract-plugin
export default {"assign":"AssignTo_assign__uHnxN","buttons":"AssignTo_buttons__eTxO5","only_approve":"AssignTo_only_approve__1g9m1"};